import { render } from "./EditorIcon.vue?vue&type=template&id=e4d1183c"
import script from "./EditorIcon.vue?vue&type=script&lang=js"
export * from "./EditorIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__